import type { FIXED_INDENTS } from 'vars/index'

import { styled } from '@linaria/react'
import { INDENTS } from 'vars/index'

export const PlayerGoLivePopupSmallSC = styled.div<{
  gap: FIXED_INDENTS
}>`
  display: flex;
  position: relative;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: ${({ gap }) => `var(${gap})`};
  padding: var(${INDENTS.INDENT_50});
`

export const PlayerGoLivePopupSC = styled.div<{
  gap: FIXED_INDENTS
}>`
  position: absolute;
  top: 50vh;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: ${({ gap }) => `var(${gap})`};
  padding: var(${INDENTS.INDENT_50});
`

export const PlayerGoLivePopupButtonSC = styled.div<{
  isSmallPlayer: boolean
}>`
  display: flex;
  width: ${({ isSmallPlayer }) => (isSmallPlayer ? '168px' : 'initial')};
  height: 48px;
`
